export default __webpack_public_path__ + "static/media/order-confirm-grey-logo.e252ace9.svg";